import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const user = this.authService.getCurrentUser();
    if (!user) return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    if (user.role === 'recruiter') return this.router.createUrlTree(['/recruitment']);
    return true;
  }
}
